import { render } from "./ValidationFeedback.vue?vue&type=template&id=49031aaa"
import script from "./ValidationFeedback.vue?vue&type=script&lang=js"
export * from "./ValidationFeedback.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__